// Registry for APP defined layers separate from tenant layer defined configurations.
// Operational layers follow same pattern as LayerDefinitions type but are hardcoded.

import {
  FieldType,
  GeometryType,
  LayerDefinition,
  LayerType,
  SystemLayerKey,
} from '@packages/database/types';

export const APP_LAYER_REGISTRY: LayerDefinition[] = [
  {
    id: '',
    key: SystemLayerKey.CREW_LOCATION,
    isVisible: true,
    opacity: 1,
    // @ts-ignore
    canEdit: false, // extend to permissions
    displayName: 'Crew Locations',
    layerType: LayerType.OPERATIONAL,
    category: 'OPERATIONAL',
    geomType: GeometryType.POINT,
    sourceFilter: null,
    styles: {
      color: '#0a24e9',
      opacity: 0.3,
      lineWidth: 2,
      strokeColor: '#059669',
      showLabel: true,
      label: { field: 'name' },
    },
    // schemaConfig: {
    //   properties: [
    //     {
    //       column: 'latitude',
    //       alias: 'latitude',
    //       fieldLabel: 'Latitude',
    //       fieldName: 'latitude',
    //       fieldType: FieldType.NUMBER,
    //       isEditable: false,
    //       isRequired: false,
    //       isSearchable: false,
    //       isLabel: false,
    //       showInForm: false,
    //       showInPopup: true,
    //       showInCard: true,
    //       showInDetail: true,
    //     },
    //     {
    //       column: 'longitude',
    //       alias: 'longitude',
    //       fieldLabel: 'Longitude',
    //       fieldName: 'longitude',
    //       fieldType: FieldType.NUMBER,
    //       isEditable: false,
    //       isRequired: false,
    //       isSearchable: false,
    //       isLabel: false,
    //       showInForm: false,
    //       showInPopup: true,
    //       showInCard: true,
    //       showInDetail: true,
    //     },
    //     {
    //       column: 'heading',
    //       alias: 'heading',
    //       fieldLabel: 'Heading',
    //       fieldName: 'heading',
    //       fieldType: FieldType.NUMBER,
    //       isEditable: false,
    //       isRequired: false,
    //       isSearchable: false,
    //       isLabel: false,
    //       showInForm: false,
    //       showInPopup: true,
    //       showInCard: true,
    //       showInDetail: true,
    //     },
    //     {
    //       column: 'speed',
    //       alias: 'speed',
    //       fieldLabel: 'Speed',
    //       fieldName: 'speed',
    //       fieldType: FieldType.NUMBER,
    //       isEditable: false,
    //       isRequired: false,
    //       isSearchable: false,
    //       isLabel: false,
    //       showInForm: false,
    //       showInPopup: true,
    //       showInCard: true,
    //       showInDetail: true,
    //     },
    //     {
    //       column: 'accuracy',
    //       alias: 'accuracy',
    //       fieldLabel: 'Accuracy',
    //       fieldName: 'accuracy',
    //       fieldType: FieldType.NUMBER,
    //       isEditable: false,
    //       isRequired: false,
    //       isSearchable: false,
    //       isLabel: false,
    //       showInForm: false,
    //       showInPopup: true,
    //       showInCard: true,
    //       showInDetail: true,
    //     },
    //   ],
    // },
  },
];

// export const getFeatureRegistry = (key: string): FeatureBehavior =>
//   FEATURE_REGISTRY[key] || DEFAULT_BEHAVIOR;
